import React from "react"
import { Header, Icon, Segment, Table } from "semantic-ui-react"

/**
 * Renders the body of the BifrostTable component.
 * It randers the data rows using the Row component.
 *
 * @param {Object} props - The component props.
 * @param {Array} props.items - The array of items to render.
 * @param {React.Component} props.Row - The component used to render each row.
 * @returns {JSX.Element} The rendered BifrostTable body.
 */
const BifrostTableBody = ({ items, Row }) => {
	return (
		<Table.Body>
			{items.length === 0 && (
				<Table.Row>
					<Table.Cell style={{ paddingTop: "40px", textAlign: "center", fontSize: "20px" }} colSpan={100} rowSpan={2}>
						<Segment basic>
							<Header icon>
								<Icon name="search" color="grey" style={{ marginBottom: "20px" }} />
								No results found
							</Header>
						</Segment>
					</Table.Cell>
				</Table.Row>
			)}
			{items.map((item, idx) => (
				<Row item={item} key={idx} />
			))}
		</Table.Body>
	)
}

export default BifrostTableBody
